import LinkButton from "../ui/LinkButton";
import { resolveActionLinkVariant } from "./actionLinkTypes";

/**
 * Router link styled as a button. Prefer `variant` (palette-aligned); `color` is deprecated.
 *
 * @param {import('./actionLinkTypes').ActionLinkVariant} [variant]
 * @param {string} [color] - @deprecated Use `variant` instead (`purple` | `blue` | `green` | `red`)
 */
export default function ActionLink({
  variant,
  color,
  children,
  className = "",
  ...props
}) {
  const resolvedVariant = resolveActionLinkVariant(variant, color);

  return (
    <LinkButton
      variant={resolvedVariant}
      size="sm"
      className={`min-w-[74px] ${className}`.trim()}
      {...props}
    >
      {children}
    </LinkButton>
  );
}

export { ACTION_LINK_VARIANTS, LEGACY_COLOR_TO_VARIANT, resolveActionLinkVariant } from "./actionLinkTypes";
